<template>
    <div v-if="payments" class="page-launchpad">
        <Merchant v-if="deposit" v-bind:transaction.sync="deposit" launchpad @statusMerchant="statusMerchant" v-bind:payments="replenishPayments" @cancelTransactions="cancelTransactions"></Merchant>
        <!--<div class="block-deposit" v-else>
            <div class="wrapper-payment-select">
                <div class="wrapper-payment-select__item">
                    <span>{{__('Choose a currency to buy a MIND token')}}</span>
                    <v-select
                            dense
                            filled
                            solo
                            v-model="payment"
                            :items="replenishPayments"
                            :filter="customFilter"
                            item-color="white"
                            :menu-props="{ bottom: true, offsetY: true }"
                            @change="calcSum(calc_give, 'give')"
                    >
                        <template v-slot:selection="data">
                            <div class="img" :class="data.item.name_class"></div>
                            {{ data.item.name }}
                            <img class="chevron-icon" src="/dist/images/frontend/chevron-down.svg" alt />
                        </template>
                        <template v-slot:item="data">
                            <template>
                                <div class="wrap-item-select-launchpad">
                                    <div class="img" :class="data.item.name_class"></div>
                                    <v-list-item-title v-html="data.item.name" class='menu-item'></v-list-item-title>
                                </div>
                            </template>
                        </template>
                    </v-select>
                </div>

                <div class="block-info-price">
                    <p class="block-info-price__title">{{__('1 MIND equals')}}</p>
                    <span class="block-info-price__subtitle">{{__('0.005 USD')}}</span>
                </div>
            </div>

            <div class="wrapper-inputs">
                <div class="wrapper-inputs__item">
                    <div class="d-flex justify-content-between">
                        <p class="text text&#45;&#45;label">{{__('Amount to deposit')}}</p>
                        <p class="text text&#45;&#45;label" @click="addMin()" style="cursor: pointer">{{__('Min')}} {{payment.min_replenish}} {{payment.currency.toUpperCase()}}</p>
                    </div>
                    <InputLabelTextDefault
                            color="border"
                            :placeholder="__('0')"
                            ref="calc_give"
                            type="number"
                            v-model="calc_give"
                            v-bind:errors="formValidate.amount_coin"
                            @input="calcSum(calc_give, 'give')"
                    >
                        <template v-slot:right>
                            <div class="currency">
                                {{payment.currency.toUpperCase()}}
                            </div>
                        </template>
                    </InputLabelTextDefault>
                </div>

                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.71 9.29L17.71 5.29C17.6168 5.19676 17.5061 5.1228 17.3843 5.07234C17.2624 5.02188 17.1319 4.99591 17 4.99591C16.7337 4.99591 16.4783 5.1017 16.29 5.29C16.1017 5.47831 15.9959 5.7337 15.9959 6C15.9959 6.2663 16.1017 6.5217 16.29 6.71L18.59 9H7.00002C6.7348 9 6.48045 9.10536 6.29291 9.2929C6.10537 9.48043 6.00002 9.73479 6.00002 10C6.00002 10.2652 6.10537 10.5196 6.29291 10.7071C6.48045 10.8946 6.7348 11 7.00002 11H21C21.1974 10.999 21.3902 10.9396 21.5539 10.8293C21.7176 10.7189 21.845 10.5626 21.92 10.38C21.9966 10.1979 22.0175 9.99718 21.9801 9.80319C21.9428 9.6092 21.8488 9.43063 21.71 9.29ZM17 13H3.00002C2.80259 13.001 2.60988 13.0604 2.44616 13.1707C2.28244 13.2811 2.15504 13.4374 2.08002 13.62C2.00344 13.8021 1.98252 14.0028 2.01989 14.1968C2.05726 14.3908 2.15126 14.5694 2.29002 14.71L6.29002 18.71C6.38298 18.8037 6.49358 18.8781 6.61544 18.9289C6.7373 18.9797 6.86801 19.0058 7.00002 19.0058C7.13203 19.0058 7.26274 18.9797 7.38459 18.9289C7.50645 18.8781 7.61705 18.8037 7.71002 18.71C7.80375 18.617 7.87814 18.5064 7.92891 18.3846C7.97968 18.2627 8.00582 18.132 8.00582 18C8.00582 17.868 7.97968 17.7373 7.92891 17.6154C7.87814 17.4936 7.80375 17.383 7.71002 17.29L5.41002 15H17C17.2652 15 17.5196 14.8946 17.7071 14.7071C17.8947 14.5196 18 14.2652 18 14C18 13.7348 17.8947 13.4804 17.7071 13.2929C17.5196 13.1054 17.2652 13 17 13Z" fill="#96AFD1"/>
                </svg>

                <div class="wrapper-inputs__item">
                    <p class="text text&#45;&#45;label">{{__('You receive')}}</p>
                    <InputLabelTextDefault
                            style="width: 100%"
                            :placeholder="__('0')"
                            color="border"
                            disabled
                            type="number"
                            v-model="calc_get"
                    >
                        <template v-slot:right>
                            <div class="currency">
                                <img src="/dist/images/frontend/light-coin.svg" alt />
                            </div>
                        </template>
                    </InputLabelTextDefault>
                </div>
            </div>
            <div class="block-bottom">
                <BaseButton
                        width="175"
                        v-on:click="onSubmit"
                        :loading="submitDisabled"
                >
                    <span>{{__('Buy MIND')}}</span>
                </BaseButton>
                <div class="block-bottom__info">
                    <p style="color: #00C443" v-if="payment.pay_commission== 2">{{__('Will be charged')}} {{(Number(calc_give)+commission).toFixed(2)}} {{payment.currency.toUpperCase()}}</p>
                    <p>
                        {{__('Payment system commission')}}
                        <span v-if="payment.replenish_pay_commission== 'percent'">{{payment.replenish_commission}}%</span>
                        <span v-else>{{commission}} {{payment.currency.toUpperCase()}}</span>
                    </p>
                </div>
            </div>
        </div>-->

        <div class="block-description">
            <svg width="115" height="104" viewBox="0 0 115 104" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1028_780)">
                    <rect y="-54" width="158" height="158" rx="79" fill="white"/>
                    <path d="M54.6448 49.1197C55.9267 51.3433 59.3254 50.4338 59.3254 47.8671V-7.64664C59.3254 -11.457 62.4098 -14.5459 66.2146 -14.5459H105.9C107.159 -14.5459 107.677 -16.101 106.628 -16.7996C98.6955 -22.0822 89.1732 -25.1602 78.9331 -25.1602C58.8843 -25.1602 41.5871 -13.3615 33.5871 3.68082C32.0574 6.93954 32.5067 10.7193 34.3046 13.838L54.6448 49.1197Z" fill="#00AEFF"/>
                    <path d="M66.9167 -8.19765C65.2902 -8.19765 64.7132 -6.04114 66.1218 -5.22667L117.093 24.245C120.388 26.1502 121.517 30.3697 119.615 33.6696L99.7726 68.0882C99.1426 69.1809 100.229 70.4071 101.357 69.8466C109.892 65.6083 117.315 58.8886 122.435 50.0074C132.825 31.9851 130.776 10.1889 118.956 -5.41066C117.575 -7.2336 115.371 -8.19776 113.086 -8.19775L66.9167 -8.19765Z" fill="#01DF72"/>
                    <path d="M113.65 31.023C114.463 29.6124 112.887 28.0337 111.478 28.8481L60.5063 58.3198C57.2113 60.225 52.9979 59.0944 51.0955 55.7945L31.253 21.3759C30.6231 20.2832 29.0197 20.6121 28.94 21.8712C28.338 31.3921 30.4374 41.1897 35.5575 50.0709C45.9474 68.0933 65.8202 77.2145 85.22 74.7629C87.487 74.4764 89.4224 73.0477 90.5649 71.0659L113.65 31.023Z" fill="#026EED"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M79 104C122.63 104 158 68.6305 158 25C158 -18.6305 122.63 -54 79 -54C35.3695 -54 0 -18.6305 0 25C0 68.6305 35.3695 104 79 104ZM78.999 86.4457C112.934 86.4457 140.443 58.9361 140.443 25.0012C140.443 -8.9336 112.934 -36.4432 78.999 -36.4432C45.0642 -36.4432 17.5546 -8.9336 17.5546 25.0012C17.5546 58.9361 45.0642 86.4457 78.999 86.4457Z" fill="url(#paint0_angular_1028_780)"/>
                    <path d="M83.602 86.4439H74.4062V103.999C77.4864 103.999 80.5513 103.966 83.602 103.908V86.4439Z" fill="white" fill-opacity="0.5"/>
                    <path d="M17.5556 20.4007H0.0919602C0.0331221 21.926 0 23.4583 0 24.9986C0 26.5389 0.0331221 28.0712 0.0919602 29.5965H17.5556V20.4007Z" fill="white" fill-opacity="0.5"/>
                    <path d="M32.6006 64.8527L19.9609 77.4924C20.9842 78.6404 22.0399 79.7664 23.1367 80.8632C24.2331 81.9596 25.3592 83.0153 26.5074 84.0389L39.1471 71.3992L32.6006 64.8527Z" fill="white" fill-opacity="0.5"/>
                </g>
                <defs>
                    <radialGradient id="paint0_angular_1028_780" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(79 25) rotate(128.904) scale(91.8484)">
                        <stop stop-color="#00AEFF"/>
                        <stop offset="0.232766" stop-color="#01DF72"/>
                        <stop offset="0.399436" stop-color="#026EED"/>
                        <stop offset="0.639026" stop-color="#00AEFF"/>
                    </radialGradient>
                    <clipPath id="clip0_1028_780">
                        <rect y="-54" width="158" height="158" rx="79" fill="white"/>
                    </clipPath>
                </defs>
            </svg>

            <div class="block-description__desc">
                <h5>🎇🎆 {{__('MIND token PRESALE from MINDPLAYS ESPORTS $100,000')}} 🎇🎆</h5>

                <p class="top-text">💶 {{__('02/20/2022 we are launching a presale of our game token MIND for 100,000 USD! Each MINDPLAYS ESPORTS user will be able to purchase MIND token with a special 50% discount on special terms!')}}</p>

                <span class="d-block mb-4">💎 {{__('1 MIND presale = $0.005')}}</span>

                <span>{{__('Presale dates:')}}</span>
                <p class="mb-0">{{__('Start: 02/20/2022 (10:00 UTC)')}}</p>
                <p class="mb-10">{{__('Finish: 02/22/2022')}}</p>

                <p>🎮 <span>{{__('MINDPLAYS ESPORTS')}}</span> — {{__('the only fair game esports platform where users can play their favorute games and earn crypto. Only fair game, real rivals and real crypto. Constant platform update and new games integration.')}}</p>

                <p>💎 <span>{{__('MIND token')}}</span> — {{__("official token of MINDPLAYS ESPORTS. Directly used as a bet token for the gaming process and commissioning. Also, MIND will be used in the platform's vote system, special events participation, NFT purchase, Staking Pool, purchase of brand merch and exclusive services (MIND application grows along with integration of new functions and platform update)")}}</p>

                <p class="mb-10">📈 {{__('MIND Tokenomics:')}} <a :href="(lang == 'ru') ? 'https://mindplays.com/Whitepaper_ru.pdf' : 'https://mindplays.com/Whitepaper.pdf'" target="_blank">{{__('Read White Paper')}}</a></p>

                <span>{{__('Participation terms:')}}</span>
                <p class="mb-0">{{__('1. Register at MINDPLAYS ESPORTS')}}</p>
                <p class="mb-0">{{__('2. Pass simple Verification')}}</p>
                <p class="mb-10">{{__('3. Buy MIND with any convenient way')}}</p>

                <span>{{__('MIND token defrost chart:')}}</span>
                <p class="mb-0">{{__('03/20/2022 + 12%')}}</p>
                <p class="mb-10">{{__('04/20/2022 - 02/20/2023 + 8% monthly')}}</p>

                <span>{{__('Mindplays remarkable roadmap stages that will increase MIND token demand:')}}</span>
                <p class="mb-0">{{__('March 2022 - Stock listing')}}</p>
                <p class="mb-0">{{__('April 2022 - Tournaments launch')}}</p>
                <p class="mb-0">{{__('May 2022 - new 2D and 3D games launch')}}</p>
                <p class="mb-0">{{__('June 2022 - official iOS/Android app release')}}</p>
                <p class="mb-0">{{__('July 2022 - MINDPLAYS ESPORTS Marketplace launch')}}</p>
                <p class="mb-0">{{__('August 2022 - Airdrop and token giveaway ends')}}</p>
                <p class="mb-0">{{__('September 2022 - ARENA 3D-shooter game release')}}</p>
            </div>
        </div>
        <div class="block-info">
            <h5 class="block-info__title">{{__('Distribution of tokens')}}</h5>

            <div class="block-info__body">
                <!--<div class="block-left">
                    <img v-if="theme == 'dark'" src="/dist/images/frontend/graphic-launchpad.png" alt="">
                    <img v-else src="/dist/images/frontend/graphic-launchpad-white.png" alt="">
                    <div class="wrap-info">
                        <div class="wrap-info__item">
                            <div class="block-name">
                                <div class="block-name__icon" style="background: #725CFA"></div>
                                <p>{{__('Token Sale')}}</p>
                            </div>

                            <span>13.6%</span>
                        </div>

                        <div class="wrap-info__item">
                            <div class="block-name">
                                <div class="block-name__icon" style="background: #019FE9"></div>
                                <p>{{__('Pre-Sale')}}</p>
                            </div>

                            <span>12.6%</span>
                        </div>

                        <div class="wrap-info__item">
                            <div class="block-name">
                                <div class="block-name__icon" style="background: #FFBA49"></div>
                                <p>{{__('AirDrop')}}</p>
                            </div>

                            <span>32.6%</span>
                        </div>

                        <div class="wrap-info__item">
                            <div class="block-name">
                                <div class="block-name__icon" style="background: #026EED"></div>
                                <p>{{__('Team')}}</p>
                            </div>

                            <span>15.7%</span>
                        </div>

                        <div class="wrap-info__item">
                            <div class="block-name">
                                <div class="block-name__icon" style="background: #01DF72"></div>
                                <p>{{__('Ads')}}</p>
                            </div>

                            <span>32.6%</span>
                        </div>
                    </div>
                </div>-->

                <div class="block-left">

                    <div class="block-total">
                        <img src="/dist/images/frontend/light-coin.svg" alt />
                        <span>1,000,000,000</span>
                        <p>{{__('Coins issued')}}</p>
                    </div>

                    <div id="chart">
                        <apexchart type="donut" width="300" :options="chartOptions" :series="series"></apexchart>
                    </div>

                    <div class="wrap-info">
                        <div class="wrap-info__item">
                            <div class="block-name">
                                <div class="block-name__icon" style="background: #019FE9"></div>
                                <p>{{__('Developers')}}</p>
                            </div>

                            <span>20%</span>
                        </div>

                        <div class="wrap-info__item">
                            <div class="block-name">
                                <div class="block-name__icon" style="background: #01DF72"></div>
                                <p>{{__('Private sale')}}</p>
                            </div>

                            <span>20%</span>
                        </div>

                        <div class="wrap-info__item">
                            <div class="block-name">
                                <div class="block-name__icon" style="background: #FFBA49"></div>
                                <p>{{__('Marketing')}}</p>
                            </div>

                            <span>4.5%</span>
                        </div>

                        <div class="wrap-info__item">
                            <div class="block-name">
                                <div class="block-name__icon" style="background: #FF4B55"></div>
                                <p>{{__('Airdrop')}}</p>
                            </div>

                            <span>0.5%</span>
                        </div>

                        <div class="wrap-info__item">
                            <div class="block-name">
                                <div class="block-name__icon" style="background: #725CFA"></div>
                                <p>{{__('Public offer')}}</p>
                            </div>

                            <span>55%</span>
                        </div>
                    </div>
                </div>

                <div class="block-right">
                    <svg width="91" height="91" viewBox="0 0 91 91" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25.7754 8.99194H58.7629C67.0615 14.8693 74.2973 22.1186 80.1593 30.4281V81.1663H25.7754V8.99194Z" fill="url(#paint0_linear_1028_829)"/>
                        <path d="M25.7754 8.99194H58.7629C67.0615 14.8693 74.2973 22.1186 80.1593 30.4281V81.1663H25.7754V8.99194Z" stroke="#C8C8C8" stroke-width="0.5"/>
                        <path d="M58.7578 8.99194C67.0461 14.8835 74.2815 22.1305 80.1599 30.4281C78.2055 28.4195 75.8359 26.8622 73.2168 25.8651C70.5977 24.8679 67.7923 24.455 64.997 24.6553C65.3956 21.7281 65.0306 18.7476 63.9374 16.0031C62.8442 13.2586 61.0599 10.8434 58.7578 8.99194Z" fill="url(#paint1_linear_1028_829)"/>
                        <path d="M58.7578 8.99194C67.0461 14.8835 74.2815 22.1305 80.1599 30.4281C78.2055 28.4195 75.8359 26.8622 73.2168 25.8651C70.5977 24.8679 67.7923 24.455 64.997 24.6553C65.3956 21.7281 65.0306 18.7476 63.9374 16.0031C62.8442 13.2586 61.0599 10.8434 58.7578 8.99194V8.99194Z" stroke="#C8C8C8" stroke-width="0.5"/>
                        <path d="M15.1836 18.473H55.2805V26.1511H15.1836V18.473Z" stroke="#C8C8C8" stroke-width="4"/>
                        <path d="M44.9853 56.4626C46.3105 53.8635 47.8291 50.9372 49.0234 47.9968L49.5012 46.8366C47.9257 40.8419 46.9816 36.0303 47.8262 32.9192C48.0033 32.5003 48.3089 32.1484 48.6988 31.9144C49.0888 31.6803 49.543 31.5761 49.996 31.6168H50.7183C52.0947 31.5969 52.7402 33.3458 52.8142 34.0255C52.8247 35.0554 52.6897 36.0817 52.4132 37.074C52.4808 36.0191 52.3247 34.9618 51.9553 33.9714C51.3866 32.723 50.8434 31.9808 50.3572 31.8585C50.1841 31.9987 50.0436 32.1748 49.9454 32.3746C49.8472 32.5745 49.7936 32.7933 49.7884 33.0159C49.644 33.8987 49.5708 34.7917 49.5694 35.6862C49.6366 38.316 50.0506 40.9254 50.8008 43.4468C50.9543 43.0032 51.0851 42.5766 51.1989 42.1756C51.3667 41.5443 52.4302 37.3669 52.4302 37.3669C52.4302 37.3669 52.1629 42.9292 51.7876 44.6099C51.7079 44.9654 51.6198 45.318 51.5259 45.6763C52.785 49.2866 54.8744 52.5507 57.6258 55.2057C58.7065 56.1432 59.8894 56.9559 61.152 57.6286C63.5212 57.2713 65.9138 57.0916 68.3097 57.0911C70.2315 56.8973 72.1644 57.3291 73.8209 58.3225C74.1859 58.6907 74.4017 59.181 74.4267 59.6988C74.4143 59.9693 74.3752 60.2379 74.3101 60.5008C74.3385 60.3557 74.3385 59.6476 72.163 58.9481C69.2671 58.3971 66.2973 58.3558 63.3872 58.8258C67.8405 61.0041 72.1829 62.0876 73.5565 61.4392C73.8464 61.2454 74.0988 61.0007 74.3015 60.7169C74.206 61.1876 74.0671 61.6483 73.8863 62.0933C73.6122 62.4415 73.2381 62.6975 72.8142 62.827C70.6416 63.3957 64.9882 62.0648 60.06 59.2495C54.4961 60.1036 49.0105 61.4075 43.6573 63.1483C38.894 71.4976 35.3109 75.3309 32.3989 73.8721L31.3268 73.3346C31.1313 73.177 30.9883 72.9637 30.9167 72.723C30.8451 72.4823 30.8483 72.2255 30.9258 71.9867C31.2642 70.3259 33.3487 67.8206 37.5347 65.3209C37.984 65.0366 39.9917 63.9872 39.9917 63.9872C39.9917 63.9872 38.5044 65.4262 38.1575 65.7077C34.8161 68.4462 32.3505 71.89 32.4102 73.2266V73.3431C35.254 72.9393 39.5054 67.1608 44.9768 56.4541L44.9853 56.4626ZM46.7115 57.3414C45.8534 58.9465 44.9756 60.541 44.0782 62.1246C48.6402 60.2963 53.3823 58.9542 58.2258 58.1206C57.6001 57.6903 56.9956 57.23 56.4143 56.7413C53.9169 54.5873 51.8849 51.9466 50.4425 48.9807C49.3877 51.8504 48.1363 54.6439 46.6972 57.3414" fill="#F91D0A"/>
                        <path d="M10.6641 14.1277H59.7586V30.63H10.6641V14.1277Z" fill="url(#paint2_linear_1028_829)"/>
                        <path d="M60.6936 31.6197H9.77344V13.1381H60.6936V31.6197ZM58.8651 14.9695H11.6048V29.7826H58.8651V14.9695Z" fill="url(#paint3_linear_1028_829)"/>
                        <path d="M23.4941 16.5478H27.0659C27.5169 16.5189 27.9688 16.5881 28.3905 16.7506C28.8122 16.9131 29.1937 17.165 29.5087 17.4891C30.1211 18.2367 30.4261 19.1893 30.3618 20.1536C30.4261 21.1223 30.1213 22.0794 29.5087 22.8325C29.1929 23.155 28.8111 23.4053 28.3894 23.5663C27.9678 23.7273 27.5162 23.7952 27.0659 23.7652H25.644V27.6014H23.4941V16.5478ZM25.6469 18.6123V21.7006H26.8384C27.0193 21.711 27.2003 21.6803 27.3677 21.6108C27.5352 21.5414 27.6847 21.435 27.8053 21.2997C28.0491 20.9724 28.1699 20.5697 28.1465 20.1622C28.1726 19.7544 28.0516 19.3507 27.8053 19.0247C27.6849 18.8892 27.5353 18.7827 27.3678 18.7132C27.2004 18.6438 27.0194 18.6132 26.8384 18.6237H25.6469V18.6123ZM34.0331 18.7119V25.4487H34.8037C35.1827 25.4741 35.5623 25.4101 35.912 25.2619C36.2617 25.1137 36.5717 24.8855 36.8171 24.5956C37.3304 23.861 37.5772 22.973 37.5167 22.0789C37.5772 21.19 37.3324 20.3071 36.8228 19.5764C36.5761 19.2865 36.265 19.0585 35.9145 18.9103C35.5639 18.7622 35.1835 18.6981 34.8037 18.7232H34.0331V18.7119ZM31.8804 16.5677H34.1554C35.1057 16.5193 36.0572 16.6357 36.9678 16.9118C37.6036 17.1592 38.1573 17.5798 38.566 18.1261C38.9653 18.6399 39.2618 19.226 39.439 19.8522C39.6381 20.5735 39.7338 21.3193 39.7234 22.0675C39.7339 22.8222 39.6381 23.5746 39.439 24.3027C39.2618 24.9289 38.9653 25.515 38.566 26.0288C38.1521 26.5767 37.5952 26.9998 36.9565 27.2516C36.0439 27.5287 35.091 27.6488 34.1383 27.6071H31.8633V16.5478L31.8804 16.5677ZM41.3671 16.5478H47.2053V18.7033H43.5369V20.7594H46.975V22.9149H43.5369V27.6014H41.3842V16.5478" fill="#FFF9F9"/>
                        <defs>
                            <linearGradient id="paint0_linear_1028_829" x1="41.6514" y1="65.5302" x2="61.7683" y2="29.1722" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#E1E1E1"/>
                            </linearGradient>
                            <linearGradient id="paint1_linear_1028_829" x1="66.9905" y1="21.985" x2="70.0845" y2="19.1328" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#C8C8C8"/>
                            </linearGradient>
                            <linearGradient id="paint2_linear_1028_829" x1="39.9803" y1="37.0569" x2="30.4423" y2="7.70087" gradientUnits="userSpaceOnUse">
                                <stop offset="0.127" stop-color="#8A0000"/>
                                <stop offset="0.244" stop-color="#900000" stop-opacity="0.999"/>
                                <stop offset="0.398" stop-color="#A00000" stop-opacity="0.999"/>
                                <stop offset="0.573" stop-color="#BC0000" stop-opacity="0.998"/>
                                <stop offset="0.761" stop-color="#E20000" stop-opacity="0.997"/>
                                <stop offset="0.867" stop-color="#FA0000" stop-opacity="0.996"/>
                            </linearGradient>
                            <linearGradient id="paint3_linear_1028_829" x1="40.3807" y1="38.22" x2="30.0892" y2="6.53778" gradientUnits="userSpaceOnUse">
                                <stop offset="0.315" stop-color="#5E0000"/>
                                <stop offset="0.444" stop-color="#830000" stop-opacity="0.999"/>
                                <stop offset="0.618" stop-color="#AE0000" stop-opacity="0.998"/>
                                <stop offset="0.775" stop-color="#CD0000" stop-opacity="0.997"/>
                                <stop offset="0.908" stop-color="#E00000" stop-opacity="0.996"/>
                                <stop offset="1" stop-color="#E70000" stop-opacity="0.996"/>
                            </linearGradient>
                        </defs>
                    </svg>
                    <a class="wrapper-links__item" :href="(lang == 'ru') ? 'https://mindplays.com/Whitepaper_ru.pdf' : 'https://mindplays.com/Whitepaper.pdf'" target="_blank">{{__('Read White Paper')}}</a>
                </div>
            </div>
        </div>

      <ModalDefault v-if="modal_cancel" v-bind:modal_cancel.sync="modal_cancel" :width="610">
        <div class="wrap-modal">
          <div class="wrap-modal__head">
            {{__('Сancel payment')}}
          </div>
          <div class="wrap-modal__body">
            <h5>{{__('Are you sure you want to cancel the transaction?')}}</h5>
            <Payment v-bind:payments="payments" v-bind:payment_id="modal_cancel.payment_id">
              <template v-slot:default="payment">
                <p class="block-row"><span>{{__('Operation ID')}}:</span> #{{modal_cancel.id}}</p>
                <p class="block-row"><span>{{__('Date of creation:')}}</span> {{modal_cancel.created_at | formatFullDate}}</p>
                <p class="block-row"><span>{{__('Amount:')}}</span> {{primNum(((modal_cancel.amount > 0) ? modal_cancel.amount : modal_cancel.amount_unit), payment.sprintf)}} {{payment.currency.toUpperCase()}}</p>
                <p class="block-row">
                  <span>{{__('Address:')}}</span>
                  <a :href="$paymentLink[payment.currency]+modal_cancel.tx" target="_blank">{{modal_cancel.tx}}</a>
                </p>
              </template>
            </Payment>
            <div class="wrap-btn">
              <v-btn
                      text
                      class="btn-cancel mr-5"
                      v-on:click="modal_cancel = false"
                      v-ripple="{ class:'secondary--text'}"
              >
                <span>{{__('No')}}</span>
              </v-btn>

              <BaseButton
                      width="100"
                      v-on:click="CancelTransactions(modal_cancel)"
                      :loading="submitDisabled"
              >
                <span>{{__('Yes')}}</span>
              </BaseButton>
            </div>
          </div>
        </div>
      </ModalDefault>
    </div>
</template>

<script>
    // import InputLabelTextDefault from "../../modules/InputLabelTextDefault";
    import BaseButton from "../../modules/BaseButton";
    import ModalDefault from "../../modules/ModalDefault";
    import Merchant from "../Balances/Merchant";
    import VueApexCharts from 'vue-apexcharts';
    import {decimal, minValue, required} from "vuelidate/lib/validators";
    import _ from 'lodash';

    export default {
        data() {
            return {
                form: {
                    wallet: 2,
                    launchpad: 1,
                    amount: 0,
                    amount_coin: 0,
                },
                formValidate: {
                    wallet: null,
                    amount: null,
                },
                deposit: this.launchpad.deposit,
                calc_give: null,
                calc_get: null,
                modal_cancel: null,


                course_lite: 0.005,
                payments: null,
                payment: null,
                submitDisabled: false,

                series: [200000000, 200000000, 45000000, 5000000, 550000000],
                chartOptions: {
                    labels: [this.__('Developers'), this.__('Private sale'), this.__('Marketing'), this.__('Airdrop'), this.__('Public offer')],

                    chart: {
                        width: 300,
                        type: 'donut',
                    },
                    plotOptions: {
                        pie: {
                            startAngle: -90,
                            endAngle: 270
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    fill: {
                        type: 'gradient',
                    },
                    legend: {
                        // formatter: function(val, opts) {
                        //     return val + " - " + opts.w.globals.series[opts.seriesIndex]
                        // },
                        show: false,
                    },
                    // responsive: [{
                    //     breakpoint: 480,
                    //     options: {
                    //         chart: {
                    //             width: 200
                    //         },
                    //         legend: {
                    //             position: 'bottom'
                    //         }
                    //     }
                    // }]
                }
            }
        },

        watch: {
            calc_give(val) {
                if(!val) {
                    this.formValidate.amount_coin = null;
                }
            }
        },
        props: {
            launchpad: {
                type: Object,
            },
        },
        methods: {
            customFilter (item, queryText) {
                const textOne = item.name.toLowerCase();
                const searchText = queryText.toLowerCase();
                return textOne.indexOf(searchText) > -1
            },
            updateValidate: function (type) {
                this.formValidate = this.$changeValidate(this.formValidate, this.$v.form[type], type);
            },
            statusMerchant(response) {
                let launchpad= this.$cleanObject(this.launchpad);

                launchpad['acquired']= response.acquired;
                launchpad['unfrozen']= response.unfrozen;

                this.$emit('update:launchpad', launchpad);
            },
            CancelTransactions(transaction) {
                let response= {
                    id: transaction.id
                };
                this.submitDisabled= true;
                this.$http
                    .post("ajax/deposit/cancel", response)
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {

                        if(this.$checkAuth(response)) {
                            response = response.data;
                            // let id= this.modal_cancel.id;

                            this.modal_cancel = false;
                            this.submitDisabled = false;
                            // if (response.deposit) {
                            //     this.deposit = response.deposit;
                            // }
                            this.deposit= null;
                            // if (response.deposit_transaction) {
                            //     this.deposit_transaction = response.deposit_transaction;
                            // }
                            // this.getTransactions(this.currentTab)
                        }
                    })
                    .catch((err) => {
                        this.httpHandler(err);
                        this.modal_cancel= false;
                        this.submitDisabled= false;
                    });

            },
            onSubmit() {
                let valid = this.$v.form;

                if (valid.$invalid) {
                    let massages = {
                        wallet: [],
                        amount:[],
                    };
                    this.formValidate = this.$formValidate(massages, valid);
                } else {
                    this.submitDisabled = true;
                    const response = this.form;
                    response.payment_id = this.payment.id;

                    console.log('responseresponseresponse');
                    console.log(response);
                    this.$http.post("ajax/deposit/create", response)
                        .then((response) => {
                            return response.json();
                        })
                        .then((response) => {
                            if (this.$checkAuth(response)) {
                                this.submitDisabled = false;
                                // response= {
                                //     "data": {
                                //         "deposit": {
                                //             "address": "TCYusJUAK1nc3TyWRNpogquehxHPbcHdHa",
                                //             "amount": 200,
                                //             "amount_unit": "1",
                                //             "rate_amount": 200,
                                //             "payment_id": 3,
                                //             "commission": 0.01,
                                //             "tag": false,
                                //             "time": "2022/02/19 12:54:16",
                                //             "step": 1,
                                //             "id": 8688,
                                //             "wallet": 2,
                                //             "status": 2,
                                //             "created_at": "2022/02/19 11:54:16"
                                //         }
                                //     },
                                //     "auth": true,
                                //     "status": 200
                                // };


                                if (response.data.action) {
                                    let form = document.createElement('form');
                                    form.action = response.data.action;
                                    form.method = response.data.method;
                                    Object.keys(response.data.form).forEach(key => {
                                        form.innerHTML += '<input type="hidden" name="' + key + '" value="' + response.data.form[key] + '">';
                                    });
                                    document.body.append(form);
                                    form.submit();
                                } else {
                                    this.deposit= response.data.deposit;
                                }
                            }
                        })
                        .catch((err) => {
                            this.submitDisabled = false;
                            let response = this.httpHandler(err);
                            if (response.error) {
                                this.formValidate = response.error.message;
                            }
                        });
                }
            },
            calcSum(val, type= 'give') {
                let payment= this.payment;
                if(type== 'give') {
                    let val_give = val;
                    if (payment.pay_commission == 1) {
                        val_give = Number(val) - this.commission;
                    }
                    let calc_get = Number(this.primNum((val_give * payment.course_usd) * 1, 2));


                    calc_get = calc_get / this.course_lite;
                    calc_get -= (calc_get / 100 * this.launchpad.percent_lite)
                    calc_get = this.primNum(calc_get, 2);

                    this.calc_get = calc_get;
                    this.form.amount = calc_get;
                    this.form.amount_coin = val;
                }
            },
            cancelTransactions(type) {
                this.modal_cancel= type;
            },
        },

        created() {
            console.log('payments_infopayments_info');
            this.$http
                .get("ajax/payments_info")
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    if(this.$checkAuth(response)) {
                        let payments = response.data.reverse();
                        this.payments = payments;
                        this.payment = payments[0];

                    }
                })
                .catch((err) => {
                    this.httpHandler(err);
                });
        },
        validations() {
            return {
                form: {
                    wallet: {
                        required,
                    },
                    amount_coin: {
                        required,
                        decimal,
                        minValue: minValue(this.payment.min_replenish)
                    },
                    amount: {
                        required,
                        decimal
                    },
                }
            }
        },
        computed: {
            lang() {
                return this.$store.getters.getLanguage;
            },
            theme() {
                return this.$store.getters.getTheme;
            },
            commission() {
                let commission= 0;

                if(this.payment.replenish_pay_commission== 'percent') {
                    commission= (this.calc_give/100)*this.payment.replenish_commission;
                } else {
                    commission= this.payment.replenish_commission;
                }

                return Number(Number(commission).toFixed(2));
            },
            replenishPayments() {
                console.log('replenishPayments');
                console.log(_.filter(this.payments, {replenish: 1}));
                return _.filter(this.payments, {replenish: 1});
            }
        },
        components: {
            // InputLabelTextDefault,
            BaseButton,
            ModalDefault,
            Merchant,
            apexchart: VueApexCharts,
        }
    }
</script>

<style lang="scss">

    .dark {
        .page-launchpad {

            .block-deposit {
                background: #171827;

                .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
                    background: #181818;
                    border-color: transparent;

                    &:hover {
                        border-color: #0F9AFF;
                        background: #181818!important;
                    }
                }
                .wrapper-payment-select {
                    .block-info-price {

                        &__title {
                            color: #fff;
                        }

                        &__subtitle {
                            color: #01DF72;
                        }
                    }

                    span {
                        color: #96AFD1;
                    }
                }

                .wrapper-inputs {
                    .currency {
                        color: #96AFD1;

                        img {
                            height: 24px;
                            width: 24px;
                        }
                    }
                }
            }

            .block-description {
                background: #171827;

                &__desc {
                    h5 {
                        color: #fff;
                    }

                    p {
                        color: #fff;
                    }

                    span {
                        color: #fff;
                    }
                }
            }

            .block-info {
                background: #171827;

                &__title {
                    color: #fff;
                }

                &__body {
                    .block-left {

                        .block-total {
                            p {
                                color: #fff;
                            }
                        }

                        .wrap-info {
                            cursor: default;

                            &__item {
                                .block-name {
                                    p {
                                        color: #fff;
                                    }
                                }

                                span {
                                    color: #fff;
                                }
                            }
                        }
                    }
                }
            }

            .text {
                &--label {
                    color: #96AFD1;
                }
            }

            .currency {
                color: #96AFD1;
            }
        }
    }

    .page-launchpad {

        .block-deposit {
            background: #fff;
            border-radius: 4px;
            padding: 20px 20px 25px;
            position: relative;
            overflow: hidden;
            margin-bottom: 20px;

            .wrapper-payment-select {
                display: flex;
                align-items: center;
                margin-bottom: 30px;

                &__item {
                    width: 50%;
                    margin-right: 62px;
                }

                svg {
                    margin: 20px 20px 0;
                    flex-shrink: 0;
                }

                span {
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 19px;
                    color: #6886AF;
                    margin-bottom: 12px;
                    display: block;
                }

                .block-info-price {
                    display: flex;
                    flex-direction: column;
                    margin-top: 28px;
                    margin-bottom: 0;
                    padding: 0;
                    width: 50%;

                    &__title {
                        font-size: 14px;
                        line-height: 19px;
                        color: #002b50;
                        margin-bottom: 0;
                    }

                    &__subtitle {
                        font-size: 30px;
                        line-height: 38px;
                        color: #01DF72;
                        margin: 0;
                    }
                }
            }

            .wrapper-inputs {
                display: flex;
                align-items: center;
                margin-bottom: 30px;

                &__item {
                    width: 50%;
                }

                svg {
                    margin: 20px 20px 0;
                }

                .currency {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    width: 25%;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 18px;
                    color: #6886AF;
                    cursor: default;
                    white-space: nowrap;


                    img {
                      height: 24px;
                      width: 24px;
                    }
                }
            }
            .block-bottom {
                display: flex;
                align-items: center;
                margin-top: 40px;

                &__info {
                    margin-left: 20px;
                }

                p {
                    font-size: 14px;
                    line-height: 19px;
                    letter-spacing: 0.001em;
                    color: #6886AF;
                    margin: 0;

                    a {
                        color: #26A9F4;

                        &:hover {
                            text-decoration: underline;
                        }
                    }
                }
            }
        }

        .block-description {
            background: #fff;
            border-radius: 4px;
            padding: 20px 20px 20px 20px;
            position: relative;
            overflow: hidden;
            margin-bottom: 20px;

            svg {
                position: absolute;
                top: 0;
                right: 0;
            }

            &__desc {
                h5 {
                    color: #002b50;
                    font-size: 16px;
                    line-height: 24px;
                    margin-bottom: 16px;
                    font-weight: 700!important;
                    padding-right: 120px;
                }

                .top-text {
                    padding-right: 120px;
                }

                p {
                    color: #002b50;
                    font-size: 14px;
                }

                span {
                    color: #002b50;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 19px;
                }

                a {
                    color: #26a9f4;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }

        .block-info {
            padding: 20px 60px 20px 20px;
            background: #fff;
            border-radius: 4px;
            position: relative;
            overflow: hidden;
            margin-bottom: 20px;

            &__title {
                font-size: 18px;
                line-height: 24px;
                color: #002b50;
                margin-bottom: 20px;
            }

            &__body {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .block-left {
                    display: flex;
                    align-items: center;
                    position: relative;
                    margin-left: -42px;


                    .block-total {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        position: absolute;
                        left: 95px;
                        top: 70px;

                        img {
                            height: 30px;
                            margin-bottom: 4px;
                        }

                        span {
                            color: #01DF72;
                            font-size: 18px;
                            line-height: 24px;
                            display: block;
                            text-align: center;
                        }

                        p {
                            margin: 0;
                            font-size: 12px;
                            line-height: 16px;
                            text-align: center;
                        }
                    }

                    .wrap-info {
                        display: flex;
                        flex-direction: column;
                        padding: 0;

                        &__item {
                            display: flex;
                            align-items: center;
                            margin-bottom: 10px;

                            .block-name {
                                display: flex;
                                align-items: center;
                                min-width: 140px;

                                &__icon {
                                    width: 10px;
                                    height: 10px;
                                    background: #725CFA;
                                    border-radius: 1px;
                                    margin-right: 9px;
                                }

                                p {
                                    font-size: 14px;
                                    line-height: 19px;
                                    color: #002b50;
                                    margin: 0;
                                }
                            }

                            span {
                                display: block;
                                font-weight: bold;
                                font-size: 14px;
                                line-height: 19px;
                                color: #002b50;
                            }
                        }
                    }
                }

                .block-right {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-bottom: 10px;

                    svg {
                        margin-bottom: 8px;
                    }
                    a {
                        color: #00AEFF;
                        font-size: 16px;
                        line-height: 22px;
                        text-align: center;

                        &:hover {
                            text-decoration: underline;
                        }
                    }
                }
            }
        }

        .text {
            font-weight: 400;
            font-size: 14px;
            line-height: 19px;
            color: #002B50;
            margin:0 0 12px;

            &--desc {
                color: #6886AF;
                margin-bottom: 10px;
            }

            &--label {
                color: #6886AF;
                position: relative;
                z-index: +1;
            }
        }

        .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
            background: #FFFFFF;
            /*height: 64px;*/
            padding: 9px 19px 9px 16px;
            border: 1px solid #EBEBEB;
            box-sizing: border-box;
            border-radius: 4px;
            box-shadow: none;
            font-weight: 400;
            font-size: 15px;
            line-height: 16px;
            letter-spacing: 0.4px;
            color: #002B50;
            position: relative;

            .v-icon.v-icon {
                font-size: 0;
            }
        }
        .theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover {
            background: transparent;
        }

        .chevron-icon {
            position: absolute;
            right: 0;
            top: 16px;
            transition-duration: .3s;
        }

        .v-select--is-menu-active {
            .chevron-icon {
                transform: rotate(180deg);
                transition-duration: .3s;
            }
        }

        .v-input--selection-controls {
            margin-top: 0px;
            padding-top: 4px;
            margin-bottom: 10px;
        }

        .v-input--radio-group.v-input--radio-group--row .v-radio {
            margin-right: 38px;
        }

        .img {
            height: 36px;
            min-width: 36px;
            margin-right: 16px;
            border-radius: 50%;
            background-size: 16px;
            background-repeat: no-repeat;
            background-position: center;
        }

        .img.btc{
            background-color: #FF7A00;
            background-image: url(/dist/images/frontend/wallets/white-btc.svg);
        }
        .img.bsc-usd_bep20 {
            background-color: #f3ba2f;
            background-image: url(/dist/images/frontend/wallets/white-usd_bep.svg);
        }
        .img.bnb{
            background-color: #f3ba2f;
            background-image: url(/dist/images/frontend/wallets/white-bnb.svg);
        }

        .img.ada{
            background-color: #2A76D0;
            background-image: url(/dist/images/frontend/wallets/white-ada.svg);
        }
        .img.dot{
            background-color: #666;
            background-image: url(/dist/images/frontend/wallets/white-dot.svg);
        }
        //
        //.img.usdt {
        //  background-color: #4FD984;
        //  background-image: url(../../../public/images/wallets/white-usdt.svg);
        //}
        .img.ltc {
            background-color: #BBBBBB;
            background-image: url(/dist/images/frontend/wallets/white-ltc.svg);
        }
        .img.doge {
            background-color: #D4BE00;
            background-image: url(/dist/images/frontend/wallets/white-doge.svg);
        }
        .img.usdt_trc20 {
            background-color: #C3332D;
            background-image: url(/dist/images/frontend/wallets/white-usd_trc.svg);
        }
        .img.eth {
            background-color: #4A84FF;
            background-image: url(/dist/images/frontend/wallets/white-eth.svg);
        }
        .img.xrp {
            background-position: 10px center;
            background-color: #2DA9E8;
            background-image: url(/dist/images/frontend/wallets/white-xrp.svg);
        }
        .img.bch {
            background-color: #8DC351;
            background-image: url(/dist/images/frontend/wallets/white-bch.svg);
        }
        .img.trx {
            background-color: #C3332D;
            background-image: url(/dist/images/frontend/wallets/white-trx.svg);
        }
        .img.link {
            background-color: #2A5ADA;
            background-image: url(/dist/images/frontend/wallets/white-link.svg);
        }
        .img.payeer {
            background-color: #2A93FF;
            background-image: url(/dist/images/frontend/wallets/white-payeer.svg);
        }
        .img.pm {
            background-color: #FF0000;
            background-image: url(/dist/images/frontend/wallets/white-pm.svg);
        }
        .img.etc {
            background-color: #1B8600;
            background-image: url(/dist/images/frontend/wallets/white-etc.svg);
        }
        .img.adv {
            background-color: #0f2d38;
            background-image: url(/dist/images/frontend/wallets/advcash.svg);
            background-size: 20px;
            background-position: 11px center;
        }
        .img.dai{
            background-image: url(/dist/images/frontend/wallets/white-dai.svg);
            background-color: #F9AC13;
        }
        .img.dash{
            background-image: url(/dist/images/frontend/wallets/dash.png);
            /*background-color: #F9AC13;*/
            background-size: 100%;
        }

        .img.mc_uah,
        .img.mc_usd,
        .img.mc_rub {
            background-image: url(/dist/images/frontend/wallets/mc_visa.svg);
            background-color: #333333;
            background-size: 30px;
        }

        .img.visa_uah,
        .img.visa_usd,
        .img.visa_rub {
            background-image: url(/dist/images/frontend/wallets/visa_icon.svg);
            background-color: #00579F;
            background-size: 26px;
        }
    }

    .dark .wrap-item-select-launchpad {
        .menu-item {
            color: #fff;
        }
    }

    .v-list {
        padding: 0;
    }

    .wrap-item-select-launchpad {
        display: flex;
        align-items: center;
        padding: 10px 0;

        .payment-item__icon {
            height: 36px;
            width: 36px;
            margin-right: 16px;
        }

        .menu-item {
            font-weight: 500;
            font-size: 15px;
            line-height: 16px;
            letter-spacing: 0.4px;
            color: #002B50;
        }
        .img {
            height: 36px;
            min-width: 36px;
            margin-right: 16px;
            border-radius: 50%;
            background-size: 16px;
            background-repeat: no-repeat;
            background-position: center;
        }

        .img.silver {
            background-image: url(/dist/images/frontend/light-coin.svg);
            background-size: 40px;
        }

        .img.btc{
            background-color: #FF7A00;
            background-image: url(/dist/images/frontend/wallets/white-btc.svg);
        }
        .img.bsc-usd_bep20 {
            background-color: #f3ba2f;
            background-image: url(/dist/images/frontend/wallets/white-usd_bep.svg);
        }
        .img.bnb{
            background-color: #f3ba2f;
            background-image: url(/dist/images/frontend/wallets/white-bnb.svg);
        }

        .img.ada{
            background-color: #2A76D0;
            background-image: url(/dist/images/frontend/wallets/white-ada.svg);
        }
        .img.dot{
            background-color: #666;
            background-image: url(/dist/images/frontend/wallets/white-dot.svg);
        }
        //
        //.img.usdt {
        //  background-color: #4FD984;
        //  background-image: url(../../../public/images/wallets/white-usdt.svg);
        //}
        .img.ltc {
            background-color: #BBBBBB;
            background-image: url(/dist/images/frontend/wallets/white-ltc.svg);
        }
        .img.doge {
            background-color: #D4BE00;
            background-image: url(/dist/images/frontend/wallets/white-doge.svg);
        }
        .img.usdt_trc20 {
            background-color: #C3332D;
            background-image: url(/dist/images/frontend/wallets/white-usd_trc.svg);
        }
        .img.eth {
            background-color: #4A84FF;
            background-image: url(/dist/images/frontend/wallets/white-eth.svg);
        }
        .img.xrp {
            background-position: 10px center;
            background-color: #2DA9E8;
            background-image: url(/dist/images/frontend/wallets/white-xrp.svg);
        }
        .img.bch {
            background-color: #8DC351;
            background-image: url(/dist/images/frontend/wallets/white-bch.svg);
        }
        .img.trx {
            background-color: #C3332D;
            background-image: url(/dist/images/frontend/wallets/white-trx.svg);
        }
        .img.link {
            background-color: #2A5ADA;
            background-image: url(/dist/images/frontend/wallets/white-link.svg);
        }
        .img.payeer {
            background-color: #2A93FF;
            background-image: url(/dist/images/frontend/wallets/white-payeer.svg);
        }
        .img.pm {
            background-color: #FF0000;
            background-image: url(/dist/images/frontend/wallets/white-pm.svg);
        }
        .img.etc {
            background-color: #1B8600;
            background-image: url(/dist/images/frontend/wallets/white-etc.svg);
        }
        .img.adv {
            background-color: #0f2d38;
            background-image: url(/dist/images/frontend/wallets/advcash.svg);
            background-size: 20px;
            background-position: 11px center;
        }
        .img.dai{
            background-image: url(/dist/images/frontend/wallets/white-dai.svg);
            background-color: #F9AC13;
        }
        .img.dash{
            background-image: url(/dist/images/frontend/wallets/dash.png);
            /*background-color: #F9AC13;*/
            background-size: 100%;
        }

        .img.mc_uah,
        .img.mc_usd,
        .img.mc_rub {
            background-image: url(/dist/images/frontend/wallets/mc_visa.svg);
            background-color: #333333;
            background-size: 30px;
        }

        .img.visa_uah,
        .img.visa_usd,
        .img.visa_rub {
            background-image: url(/dist/images/frontend/wallets/visa_icon.svg);
            background-color: #00579F;
            background-size: 26px;
        }
    }

    @media screen and (max-width: 1100px) {
        .page-launchpad {
            .block-info {
                padding: 20px;

                &__body {
                    .block-left {
                        /*img {*/
                        /*    margin-right: 40px;*/
                        /*}*/

                        .wrap-info {
                            margin-left: -15px;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 950px) {
        .page-launchpad {
            .block-info {
                padding: 20px 60px 20px 20px;

                &__body {
                    .block-left {
                        /*img {*/
                        /*    margin-right: 60px;*/
                        /*}*/

                        .wrap-info {
                            margin-left: 0;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 750px) {
        .page-launchpad {
            .block-info {
                padding: 20px;

                &__body {
                    .block-left {
                        /*img {*/
                        /*    margin-right: 40px;*/
                        /*}*/
                    }
                }
            }
        }
    }

    @media screen and (max-width: 700px) {
        .page-launchpad {
            .block-deposit {
                .wrapper-payment-select {
                    flex-direction: column-reverse;
                    margin-bottom: 20px;

                    &__item {
                        width: 100%;
                        margin: 0;
                    }

                    .block-info-price {
                        margin: 0 0 15px;
                        flex-direction: row;
                        align-items: center;
                        width: 100%;

                        &__title {
                            margin-right: 6px;
                            font-size: 16px;
                            line-height: 21px;
                        }

                        &__subtitle {
                            font-size: 16px;
                            line-height: 21px;
                        }
                    }
                }

                .wrapper-inputs {
                    flex-direction: column;
                    margin-bottom: 0;

                    &__item {
                        width: 100%;
                        margin-bottom: 20px;
                    }

                    svg {
                        display: none;
                    }
                }

                .block-bottom {
                    margin-top: 30px;
                }
            }
        }
    }

    @media screen and (max-width: 650px) {
        .page-launchpad {
            .block-info {
                .block-right {
                    display: none;
                }
            }
        }
    }

    @media screen and (max-width: 550px) {
        .page-launchpad {
            .block-deposit {
                .block-bottom {
                    margin-top: 10px;
                    flex-direction: column;

                    &__info {
                        margin: 10px 0 0;

                        p {
                            text-align: center;
                        }
                    }
                }
            }

            .block-description {
                svg {
                    width: 70px;
                    height: 55px;
                }

                &__desc {

                    h5 {
                        padding-right: 60px;
                    }

                    .top-text {
                        padding-right: 0;
                    }
                }
            }

            .block-info {
                &__body {
                    .block-left {
                        flex-direction: column;
                        margin: 0 auto;
                        align-items: center;

                        .wrap-info {
                            margin-top: 10px;
                        }
                    }
                }
            }
        }
    }


</style>